/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const medicalMessages: SegmentSpecificMessages = {
  emailExplanation: "Use your work email if you have one",
  step: {
    personalInfo: {
      title: "Unlock this Medical Professional-Only Offer",
      subtitle: "Verify you're a licensed medical professional.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must be a medical care professional and be a member of an eligible group of the medical care profession. " +
        "Eligible groups are shown in the Status selector of this form." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a medical professional. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check your Name, Birthdate & Organization",
        subtitle:
          "Your first and last name, birthdate and organization must match what is on your official documents.",
      },
      verifyingTitle: "Verifying your medical professional status",
      submitButtonText: "Verify My Medical Professional Status",
    },
    docUpload: {
      uploadInstructions: "Upload an official document that shows",
      title: "To continue, upload documents that confirm your medical status",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying medical professionals.",
    },
    sso: {
      title: "Verify your Healthcare status",
      subtitle: "Please sign into your employer's web portal. It will open in a new tab.",
      login: "Sign into my employer web portal",
      alternative: "You can also verify by uploading proof of employment",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
